import { render, staticRenderFns } from "./QuestionSettings.vue?vue&type=template&id=c56eda7e&scoped=true"
import script from "./QuestionSettings.vue?vue&type=script&lang=js"
export * from "./QuestionSettings.vue?vue&type=script&lang=js"
import style0 from "./QuestionSettings.vue?vue&type=style&index=0&id=c56eda7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56eda7e",
  null
  
)

export default component.exports